import {getMsgList, getMsgType} from "../../../api/server/message"
import Nomsg from "../../../components/Nomsg"
import commonMixin from "../../../mixin/common"
export default {
  name: 'MessagePage',
  mixins: [commonMixin],
  data () {
    return {
      id: null,
      typelist: null,
      list: null
    }
  },
  components: {
    nomsg: Nomsg
  },
  computed: {
  },
  methods: {
    onChange (eid = 0) {
      let id = eid
      let currentId = ''
      if (id) {
        currentId = id
      }
      this.id = currentId
      this.list = null
      this._getList()
    },
    onDetail (id) {
      this.$router.push({name: 'message-detail', query: {id: id}})
    },
    _getList () {
      let id = this.id
      if (!this.id) {
        id = ''
      }
      let query = {
        type: id
      }
      getMsgList(query).then((res) => {
          if (res.code === 200 && res.data) {
            this.list = res.data.data
          }
        }
      )
    },
    _getType () {
      getMsgType(null).then((res) => {
        if (res.code === 200) {
          this.typelist = res.data
        }
      })
    },
    reset () {
      this._getType()
      this._getList(null)
    },
    handleRoute (route) {
      if (route.name === 'message') {
        this.id = route.query.id
        this.reset()
      }
    }
  },
  watch: {
    'route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}